import { KnmResultDecisionStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionStatusEnum';

export const mapResultDecisionStatusToLabel: Record<KnmResultDecisionStatusEnum, string> = {
  [KnmResultDecisionStatusEnum.COMPLETED]: 'Исполнено',
  [KnmResultDecisionStatusEnum.NOT_COMPLETED]: 'Не исполнено',
  [KnmResultDecisionStatusEnum.CANCELED]: 'Отменено',
};
